export const EXTERNAL_UUID_PARAM_NAME = 'ext_id';
export const URL_UUID_PARAM_NAME = 'customerUuid';
export const hasValidVoucherData = ({ voucherType, activationId, discountVoucherId, returnIncentiveId, }) => {
    switch (voucherType) {
        case 'discountVoucher':
            return Boolean(discountVoucherId) && Boolean(activationId);
        case 'riVoucher':
            return Boolean(returnIncentiveId);
        default:
            return false;
    }
};
export const buildDiscountVoucherRedirectLocation = ({ url, customerUuid, discountVoucherId, activationId, ext_id, }) => {
    const params = new URLSearchParams();
    if (customerUuid)
        params.set('customerUuid', customerUuid);
    if (activationId)
        params.set('activationId', activationId);
    if (discountVoucherId)
        params.set('discountVoucherId', discountVoucherId);
    if (ext_id)
        params.set('ext_id', ext_id);
    return `${url}?${params.toString()}`;
};
export const buildRIVoucherRedirectLocation = ({ url, customerUuid, returnIncentiveId, ext_id, }) => {
    const params = new URLSearchParams();
    if (customerUuid)
        params.set('customerUuid', customerUuid);
    if (returnIncentiveId)
        params.set('returnIncentiveId', returnIncentiveId);
    if (ext_id)
        params.set('ext_id', ext_id);
    return `${url}?${params.toString()}`;
};
